import UnitWarningContainer from "./UnitWarningContainer"

export default function PendingNsfWarning({ unit }) {
  if (!unit.attributes["is-nsf"]) {
    return null
  }

  return (
    <UnitWarningContainer colorStyles="text-fpx-red border-fpx-red">
      <span>This unit has a pending NSF.</span>
    </UnitWarningContainer>
  )
}
